module.exports = __webpack_public_path__ + "fonts/ralewaythin.22c5a4b.ttf";